import styles from './cancellationCard.module.scss';

export default function CancellationCard() {
  return (
    <div className={styles.cancellationCard}>
      <h3 className={styles.title}>Cancellations</h3>
      <div>
        Visit your account to{' '}
        <span className={styles.highlight}>manage your registration.</span>
      </div>
    </div>
  );
}
